module.exports = __webpack_public_path__ + "static/media/filterIconDark.2f008066.svg";